module.exports = __webpack_public_path__ + "img/Icon-Labs.b7a95526.svg";